import React from 'react';
import { Route } from 'react-router';
import ForgotPassword from '../screens/auth/ForgotPassword';
import ResetPassword from '../screens/auth/ResetPassword';
import Login from '../screens/auth/Login';
import Register from '../screens/auth/Register';
import RoutesConst from '../../blocks/consts/RoutesConst';
import TermsOfUse from '../screens/TermsOfUse';
import Contact from '../screens/Contact';
import FrequentlyAskedQuestions from '../screens/FrequentlyAskedQuestions';
import SellingSpots from '../screens/SellingSpots';
import RouteCalculation from '../screens/RouteCalculation';
import EWallet from '../screens/EWallet';
import PaymentInfo from '../screens/PaymentInfo';
import BusLines from '../screens/BusLines';
import VerifyActivationMail from '../screens/auth/VerifyActivationMail';
import Dashboard from '../screens/Dashboard';
import MyProfile from '../screens/my-profile/MyProfile';
import MyTransactions from '../screens/MyTransactions';
import MyCoupons from '../screens/MyCoupons';
import ActivateFullProfile from '../screens/ActivateFullProfile';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../store';
import PenaltyPay from '../screens/PenaltyPay';

const Routes = () => {
    const isAuthenticated = useSelector((state: ApplicationState) => state.auth.isAuthenticated);

    const getHomeComponent = () => {
        if (isAuthenticated)
            return Dashboard;

        return Login;
    }

    return (
        <>
            <Route exact path={RoutesConst.Home} component={getHomeComponent()} />
            <Route exact path={RoutesConst.Login} component={Login} />
            <Route exact path={RoutesConst.Register} component={Register} />
            <Route exact path={RoutesConst.ForgotPassword} component={ForgotPassword} />
            <Route exact path={RoutesConst.ResetPassword} component={ResetPassword} />
            <Route exact path={RoutesConst.VerifyAccountMail} component={VerifyActivationMail} />
            <Route exact path={RoutesConst.EWallet} component={EWallet} />
            <Route exact path={RoutesConst.PaymentInfo} component={PaymentInfo} />
            <Route exact path={RoutesConst.RouteCalculation} component={RouteCalculation} />
            <Route exact path={RoutesConst.BusLines} component={BusLines} />
            <Route exact path={RoutesConst.SellingSpots} component={SellingSpots} />
            <Route exact path={RoutesConst.FrequentylAskedQuestions} component={FrequentlyAskedQuestions} />
            <Route exact path={RoutesConst.TermsOfUse} component={TermsOfUse} />
            <Route exact path={RoutesConst.Contact} component={Contact} />
            <Route exact path={RoutesConst.Dashboard} component={Dashboard} />
            <Route exact path={RoutesConst.MyProfile} component={MyProfile} />
            <Route exact path={RoutesConst.MyTransactions} component={MyTransactions} />
            <Route exact path={RoutesConst.MyCoupons} component={MyCoupons} />
            <Route exact path={RoutesConst.ActivateFullProfile} component={ActivateFullProfile} />
            <Route exact path={RoutesConst.PenaltyPay} component={PenaltyPay} />
        </>
    );
}

export default Routes;
